/* Hollow Hunt: skill-based discount game (ANIME STYLE). Slash hollow masks, spare the souls. */
(function () {
  'use strict';
  var root = document.querySelector('[data-as-hunt]');
  if (!root) return;
  var S = window.asHuntStrings || {};

  /* ---------- tuning: hard on purpose ---------- */
  var LIFE_START = 1000, LIFE_END = 420;      /* how long a mask stays (ms), shrinks over the round */
  var SPAWN_START = 650, SPAWN_END = 280;     /* time between spawns (ms) */
  var MAX_ON_START = 2, MAX_ON_END = 4;       /* masks on screen at once */
  var P_SOUL = 0.2, P_MENOS = 0.07, P_GOLD = 0.04;
  var MENOS_HITS = 3, MENOS_LIFE = 1600;
  var GOLD_LIFE_FACTOR = 0.7;
  var POINTS = { hollow: 10, gold: 40, menos: 50, soul: -30, miss: -5 };
  var COMBO_STEPS = [[28, 4], [16, 3], [8, 2], [0, 1]];
  var MIN_GAP = 76;                           /* px between masks */
  var KEY_CLOSED = 'as-hunt-closed-at', KEY_CLAIMED = 'as-hunt-claimed', KEY_GRADE = 'as-hunt-grade', KEY_BEST = 'as-hunt-best';

  var seconds = Number(root.dataset.seconds) || 30;
  var limits = { s: Number(root.dataset.s), a: Number(root.dataset.a) };
  var codes = root.dataset.codes.split('|');
  var q = function (sel) { return root.querySelector(sel); };
  var field = q('[data-hunt-field]'), call = q('[data-hunt-call]');
  var fab = document.querySelector('[data-hunt-open]');
  var store = {
    get: function (k, s) { try { return (s ? sessionStorage : localStorage).getItem(k); } catch (e) { return null; } },
    set: function (k, v, s) { try { (s ? sessionStorage : localStorage).setItem(k, v); } catch (e) {} }
  };
  var game = null;

  var SVG = {
    hollow: '<svg viewBox="0 0 64 64"><path d="M32 4C17 4 8 15 8 29c0 9 4 15 9 19l2 10h26l2-10c5-4 9-10 9-19C56 15 47 4 32 4z" fill="#f2f0ea"/><path d="M14 22c6-2 11 0 13 6-6 1-11-1-13-6zM50 22c-6-2-11 0-13 6 6 1 11-1 13-6z" fill="#0b0b0e"/><path d="M30 6l4 0-1 22h-2z" fill="#d7141c"/><path d="M20 44h24l-2 8H22z" fill="#0b0b0e"/><path d="M24 44v8M28 44v8M32 44v8M36 44v8M40 44v8" stroke="#f2f0ea" stroke-width="1.6"/></svg>',
    gold: '<svg viewBox="0 0 64 64"><path d="M32 4C17 4 8 15 8 29c0 9 4 15 9 19l2 10h26l2-10c5-4 9-10 9-19C56 15 47 4 32 4z" fill="#f7c948"/><path d="M14 22c6-2 11 0 13 6-6 1-11-1-13-6zM50 22c-6-2-11 0-13 6 6 1 11-1 13-6z" fill="#3a2600"/><path d="M20 44h24l-2 8H22z" fill="#3a2600"/></svg>',
    menos: '<svg viewBox="0 0 64 64"><path d="M32 2c-10 0-16 8-16 18v24c0 10 6 18 16 18s16-8 16-18V20C48 10 42 2 32 2z" fill="#d9d9e2"/><circle cx="25" cy="22" r="4" fill="#0b0b0e"/><circle cx="39" cy="22" r="4" fill="#0b0b0e"/><path d="M32 26l3 22h-6z" fill="#b9b9c4"/><path d="M26 52h12" stroke="#0b0b0e" stroke-width="2"/></svg>',
    soul: '<svg viewBox="0 0 64 64"><path d="M32 4c6 10 18 16 18 32a18 18 0 0 1-36 0c0-8 4-12 8-16 0 6 2 9 5 10-1-10 2-18 5-26z" fill="#5aaaff" opacity=".9"/><path d="M32 22c3 6 9 9 9 18a9 9 0 0 1-18 0c0-6 5-9 9-18z" fill="#cfe6ff"/><circle cx="28.5" cy="40" r="1.6" fill="#0b2a52"/><circle cx="35.5" cy="40" r="1.6" fill="#0b2a52"/></svg>'
  };

  function lerp(a, b, t) { return a + (b - a) * Math.min(1, Math.max(0, t)); }
  function multiplier(combo) { for (var i = 0; i < COMBO_STEPS.length; i++) if (combo >= COMBO_STEPS[i][0]) return COMBO_STEPS[i][1]; return 1; }
  function fill(str, vars) { return Object.keys(vars).reduce(function (s, k) { return s.split('{{ ' + k + ' }}').join(vars[k]); }, str || ''); }

  /* ---------- popup ---------- */
  function step(name) { root.querySelectorAll('[data-hunt-step]').forEach(function (p) { p.hidden = p.dataset.huntStep !== name; }); }
  function resetScene() {
    field.innerHTML = '';
    call.textContent = '';
    q('[data-hunt-score]').textContent = '';
    q('[data-hunt-combo]').textContent = '';
    q('[data-hunt-time]').textContent = '';
    q('[data-hunt-bar]').style.transform = 'scaleX(1)';
  }
  function open(name) {
    name = name || 'start';
    if (name === 'start') { stop(); resetScene(); showBest(); }
    root.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    step(name);
    var f = root.querySelector('[data-hunt-step="' + name + '"] button, [data-hunt-step="' + name + '"] input');
    if (f) f.focus();
  }
  function close() {
    stop();
    root.hidden = true;
    document.documentElement.style.overflow = '';
    store.set(KEY_CLOSED, String(Date.now()));
  }
  function showBest() {
    var el = q('[data-hunt-best]'), best = Number(store.get(KEY_BEST)) || 0;
    if (el && best) { el.textContent = fill(S.best, { score: best }); el.hidden = false; }
  }
  function gradeFor(score) { return score >= limits.s ? 's' : (score >= limits.a ? 'a' : 'b'); }
  function gradeIndex(g) { return { s: 0, a: 1, b: 2 }[g]; }
  /* the discount size is never shown: the grade alone tells the player how well they did */
  function showGrade(g) {
    root.querySelectorAll('[data-hunt-grade]').forEach(function (el) { el.textContent = g.toUpperCase(); });
    q('[data-hunt-tags]').value = 'newsletter,hollow-hunt,hollow-hunt-' + g + '-rank';
  }
  function showCode(g) {
    showGrade(g);
    var code = codes[gradeIndex(g)] || '';
    q('[data-hunt-code]').textContent = code;
    var apply = q('[data-hunt-apply]');
    if (code && apply) apply.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(apply.getAttribute('href'));
    open('code');
  }

  /* ---------- the hunt ---------- */
  function stop() {
    if (!game) return;
    game.over = true;
    cancelAnimationFrame(game.raf);
    clearTimeout(game.countdown);
    game = null;
  }

  function hud() {
    q('[data-hunt-score]').textContent = game.score;
    var m = multiplier(game.combo);
    q('[data-hunt-combo]').textContent = game.combo >= 3 ? game.combo + ' \u00b7 x' + m : '';
  }

  function fx(x, y, text, bad) {
    var el = document.createElement('span');
    el.className = 'as-hunt__fx' + (bad ? ' as-hunt__fx--bad' : '');
    el.textContent = text;
    el.style.left = x + 'px'; el.style.top = y + 'px';
    field.appendChild(el);
    setTimeout(function () { el.remove(); }, 650);
  }

  function breakCombo() { game.combo = 0; }

  function pickType() {
    var r = Math.random();
    if (r < P_GOLD) return 'gold';
    if (r < P_GOLD + P_MENOS) return 'menos';
    if (r < P_GOLD + P_MENOS + P_SOUL) return 'soul';
    return 'hollow';
  }

  function freeSpot(size) {
    var w = field.clientWidth, h = field.clientHeight, pad = size / 2 + 4;
    for (var i = 0; i < 20; i++) {
      var x = pad + Math.random() * (w - pad * 2), y = pad + Math.random() * (h - pad * 2);
      var ok = game.targets.every(function (t) { return Math.hypot(t.x - x, t.y - y) > MIN_GAP; });
      if (ok) return { x: x, y: y };
    }
    return null;
  }

  function spawn(now, progress) {
    var type = pickType();
    var size = type === 'menos' ? 96 : 64;
    var spot = freeSpot(size);
    if (!spot) return;
    var life = lerp(LIFE_START, LIFE_END, progress);
    if (type === 'menos') life = MENOS_LIFE;
    if (type === 'gold') life *= GOLD_LIFE_FACTOR;
    var el = document.createElement('button');
    el.type = 'button';
    el.className = 'as-hunt__t as-hunt__t--' + type;
    el.setAttribute('aria-label', type);
    el.style.left = spot.x + 'px'; el.style.top = spot.y + 'px';
    el.innerHTML = SVG[type];
    var t = { el: el, type: type, x: spot.x, y: spot.y, dies: now + life, hits: 0 };
    el.addEventListener('pointerdown', function (e) { e.preventDefault(); e.stopPropagation(); hit(t); });
    field.appendChild(el);
    game.targets.push(t);
  }

  function remove(t, cls) {
    game.targets = game.targets.filter(function (x) { return x !== t; });
    t.el.classList.add(cls);
    setTimeout(function () { t.el.remove(); }, 240);
  }

  function hit(t) {
    if (!game || game.over || !game.running) return;
    game.taps += 1;
    if (t.type === 'soul') {
      game.score += POINTS.soul; breakCombo();
      fx(t.x, t.y, POINTS.soul, true);
      remove(t, 'is-hit'); hud(); return;
    }
    if (t.type === 'menos') {
      t.hits += 1;
      if (t.hits < MENOS_HITS) { t.el.classList.remove('is-shake'); void t.el.offsetWidth; t.el.classList.add('is-shake'); game.good += 1; return; }
    }
    game.good += 1;
    game.combo += 1;
    game.maxCombo = Math.max(game.maxCombo, game.combo);
    var pts = POINTS[t.type] * multiplier(game.combo);
    game.score += pts;
    fx(t.x, t.y, '+' + pts + (t.type === 'hollow' ? '' : ' \u65ac'));
    remove(t, 'is-hit'); hud();
  }

  function miss(e) {
    if (!game || !game.running || game.over) return;
    game.taps += 1;
    game.score += POINTS.miss; breakCombo();
    var r = field.getBoundingClientRect();
    fx(e.clientX - r.left, e.clientY - r.top, POINTS.miss, true);
    hud();
  }

  function loop(now) {
    if (!game || game.over) return;
    var elapsed = now - game.start, progress = elapsed / (seconds * 1000);
    q('[data-hunt-bar]').style.transform = 'scaleX(' + Math.max(0, 1 - progress) + ')';
    q('[data-hunt-time]').textContent = Math.max(0, Math.ceil(seconds - elapsed / 1000)) + 's';
    game.targets.slice().forEach(function (t) {
      if (now >= t.dies) { if (t.type !== 'soul') breakCombo(); remove(t, 'is-gone'); hud(); }
    });
    var maxOn = Math.round(lerp(MAX_ON_START, MAX_ON_END, progress));
    if (now >= game.nextSpawn && game.targets.length < maxOn) {
      spawn(now, progress);
      game.nextSpawn = now + lerp(SPAWN_START, SPAWN_END, progress) * (0.75 + Math.random() * 0.5);
    }
    if (progress >= 1) return finish();
    game.raf = requestAnimationFrame(loop);
  }

  function begin() {
    resetScene();
    step('play');
    game = { score: 0, combo: 0, maxCombo: 0, taps: 0, good: 0, targets: [], running: false, over: false, raf: 0, countdown: 0 };
    hud();
    var n = 3;
    (function tick() {
      if (!game) return;
      if (n > 0) { call.textContent = n; n -= 1; game.countdown = setTimeout(tick, 600); return; }
      call.textContent = S.go || 'Hunt!';
      game.countdown = setTimeout(function () { if (game) call.textContent = ''; }, 500);
      game.running = true;
      game.start = performance.now();
      game.nextSpawn = game.start + 200;
      game.raf = requestAnimationFrame(loop);
    })();
  }

  function finish() {
    var g = game;
    g.over = true; g.running = false;
    g.targets.forEach(function (t) { t.el.remove(); });
    call.textContent = S.over || 'Time!';
    var score = Math.max(0, g.score);
    var best = Math.max(score, Number(store.get(KEY_BEST)) || 0);
    store.set(KEY_BEST, String(best));
    var grade = gradeFor(score);
    store.set(KEY_GRADE, grade, true);
    var accuracy = g.taps ? Math.round(g.good / g.taps * 100) : 0;
    q('[data-hunt-stats]').textContent = fill(S.stats, { score: score, combo: g.maxCombo, accuracy: accuracy });
    showGrade(grade);
    game = null;
    setTimeout(function () {
      step('result');
      var email = q('#AsHuntEmail');
      if (email) email.focus();
    }, 900);
  }

  /* ---------- wiring ---------- */
  field.addEventListener('pointerdown', function (e) { if (e.target === field) { e.preventDefault(); miss(e); } });
  document.addEventListener('keydown', function (e) { if (!root.hidden && e.key === 'Escape') close(); });
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-hunt-close]')) close();
    if (e.target.closest('[data-hunt-start]')) begin();
    var codeBtn = e.target.closest('[data-hunt-code]');
    if (codeBtn && navigator.clipboard) navigator.clipboard.writeText(codeBtn.textContent).then(function () { q('[data-hunt-copied]').textContent = S.copied || 'Copied'; });
  });
  if (fab) {
    fab.hidden = false;
    fab.addEventListener('click', function () {
      var claimed = store.get(KEY_CLAIMED);
      if (claimed) showCode(claimed); else open('start');
    });
  }
  q('[data-hunt-form]').addEventListener('submit', function () { store.set('as-hunt-pending', '1', true); });

  /* the Shopify preview bar sits on the bottom-left corner: lift the button above it */
  setTimeout(function () { if (fab && document.getElementById('PBarNextFrameWrapper')) fab.style.bottom = '84px'; }, 1500);

  /* ?game=1 opens the game straight away, for testing */
  if (/[?&]game=1/.test(location.search)) { open('start'); return; }

  /* back from the email form: reveal the code */
  if (/[?&]customer_posted=true/.test(location.search) && store.get('as-hunt-pending', true) === '1') {
    var g = store.get(KEY_GRADE, true) || 'b';
    store.set(KEY_CLAIMED, g);
    store.set('as-hunt-pending', '', true);
    showCode(g);
    return;
  }

  /* visitors from Meta ads never get the automatic popup this session: the HUNT button still works */
  var KEY_ADS = 'as-hunt-from-ads';
  if (/[?&](fbclid=|utm_source=(meta|facebook|instagram|fb|ig)(&|$))/i.test(location.search)) store.set(KEY_ADS, '1', true);
  var fromAds = store.get(KEY_ADS, true) === '1';

  /* open by itself once in a while (never on top of the intro or in the theme editor) */
  var delay = Number(root.dataset.delay) * 1000;
  var days = Number(root.dataset.days) || 7;
  var recentlyClosed = Date.now() - (Number(store.get(KEY_CLOSED)) || 0) < days * 864e5;
  if (delay > 0 && !fromAds && !store.get(KEY_CLAIMED) && !recentlyClosed && root.dataset.design !== 'true') {
    /* the clock starts when the visitor is on the site, i.e. after the START screen is gone */
    var waitForIntro = function () {
      var intro = document.querySelector('.as-intro');
      if (intro && !intro.hidden) return setTimeout(waitForIntro, 500);
      setTimeout(function () {
        if (!root.hidden) return; /* already open (the visitor started from the button) */
        open('start');
      }, delay);
    };
    waitForIntro();
  }
})();
